import axios from "axios";
import { createContext, useContext, useState } from "react";


const StateContext=createContext({
user:null,
token:null,
items:[],
setItems:()=>{},
type:null,
setType:()=>{},
setUser:()=>{},
setToken:()=>{},
userId:null,
setUserId:()=>{},
handleSetPing:()=>{},
handleLogout:()=>{}

})

export const ContextProvider=({children})=>{
const [user,_setUser]=useState(localStorage.getItem('AUTH_NAME'));
const [token,_setToken]=useState(localStorage.getItem('ACCESS_TOKEN'));
const [type,_setType]=useState(localStorage.getItem('USER_TYPE'));
const [items,_setItems]=useState(localStorage.getItem('Cart'));
const [userId,_setUserId]=useState(localStorage.getItem('User_id'));
const [ping,setPing]=useState(false);

//const [weburl]=useState('https://gadgetsworld.click/softwareapis/public/images/');
const [weburl]=useState('https://hassanbookdepo.posreact.com/softwareapis/public/images/');
//const [weburl]=useState('https://bookvillage.posreact.com/softwareapis/public/images/');
//const [weburl]=useState('https://demo.posreact.com/softwareapis/public/images/');
//const [weburl]=useState('https://cafepizzaclub.posreact.com/softwareapis/public/images/');
//const [weburl]=useState('https://gaodiceramics.posreact.com/softwareapis/public/images/');
//const [weburl]=useState('https://azizks.posreact.com/softwareapis/public/images/');
const [currency]=useState('Rs');

const handleLogout = async () => {
  axios.post('/api/logout')
     .then(res => {
     
       localStorage.removeItem('ACCESS_TOKEN');
       setToken(null);
 setUser(null);
 setType(null);
 setItems(null);
 setUserId(null);
      // navigation('/login');
     })
     .catch(error => {
       if (error.response && error.response.status === 401) {
     
         localStorage.removeItem('ACCESS_TOKEN');
         setUser(null);
            setToken(null);
 setType(null);
 setItems(null);
 setUserId(null);
        // navigation('/login');
       } else {
            localStorage.removeItem('ACCESS_TOKEN');
         setUser(null);
            setToken(null);
 setType(null);
 setItems(null);
 setUserId(null);
         console.log('Error:', error);
       }
     });
   
   
  };

const setToken=(token)=>{

_setToken(token);

if(token){
localStorage.setItem('ACCESS_TOKEN',token);

}else{
localStorage.removeItem('ACCESS_TOKEN');

}

}
const handleSetPing=(ping)=>{
setPing(ping);


}
const setUserId=(userId)=>{

    _setUserId(userId);
    
    if(userId){
    localStorage.setItem('User_id',userId);
    
    }else{
    localStorage.removeItem('User_id');
    
    }
    
    }
const setUser=(user)=>{

    _setUser(user);
    
    if(user){
    localStorage.setItem('AUTH_NAME',user);
    
    }else{
    localStorage.removeItem('AUTH_NAME');
    
    }
    
    }

    const setItems=(items)=>{
        const usersString = JSON.stringify(items);
        
        _setItems(usersString);
        if(items){
            localStorage.setItem('Cart', usersString);
            
            }else{
            localStorage.removeItem('Cart');
            
            }
        
        }
    const setType=(type)=>{

        _setType(type);
        
        if(type){
        localStorage.setItem('USER_TYPE',type);
        
        }else{
        localStorage.removeItem('USER_TYPE');
        
        }
        
        }

return(

<StateContext.Provider value={{
user,
token
,
setUser,
setToken,
type,
setType,
items,
setItems,
userId,
setUserId,
weburl,
currency,
handleSetPing,
ping,
handleLogout



}}>

{children}
</StateContext.Provider>



)



}


export const useStateContext=()=>useContext(StateContext);